import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { ServerNotificationService } from 'src/app/core/services/server-notification/server-notification.service';
import { ServerNotiModel } from 'src/app/core/view-models/server-notification';

@Component({
  selector: 'app-modal-notification',
  templateUrl: './modal-notification.component.html',
  styleUrls: ['./modal-notification.component.scss']
})
export class ModalNotificationComponent implements OnInit {

  @Output() callbackUpdate: EventEmitter<any> = new EventEmitter();
  name: string = ''
  noti: ServerNotiModel = new ServerNotiModel
  innerHtml: any
  isLoginged:boolean = false
  notShow: boolean = false
  constructor(
    public activeModal: NgbActiveModal,
    private sanitized: DomSanitizer, 
    private authService: AuthService,
    private serverNotificationService: ServerNotificationService,
  ) { }

  ngOnInit(): void {
    this.checkLoginged()
    
  }
  async checkLoginged(){
    this.isLoginged = await this.authService.hasLogined()
  }
 
  async close(){
    /* if(this.isLoginged && this.notShow){
      await this.serverNotificationService.aleartOnce(this.noti.notiSysId)
    } */
    this.callbackUpdate.emit(true)
    this.activeModal.dismiss()
  }

}
